export const patterns = {
  applicationId: /^[A-Z][\d]{11}$/,
  emailAddress: /^[A-Z0-9._%+-]+@(([A-Z0-9]+-*)*[A-Z0-9]+\.)+[A-Z]{2,4}$/i,
  lastFourDigits: /^[\d]{4}$/,
  loanId: /^[0-9]{8}$|^TL[0-9]{8}$|^[0-9]{12}$/,
  loanIdOrAccountId:
    /^[A-Z][\d]{11}$|^[0-9]{8}$|^TL[0-9]{8}$|^SA[0-9]{8}$|^[0-9]{12}$/i,
  noSpecialCharacters: /^[\p{L}\s'-]+$/u,
  phoneNumber: /^([\d]{3}-?[\d]{3}-?[\d]{4})$|^([\d]{2}-?[\d]{4}-?[\d]{4})$/,
  zipOrPostalCode: /^\d{5}$|^[a-zA-Z]\d[a-zA-Z][ ]?\d[a-zA-Z]\d$/,
  verificationCode: /^\d{6}$/,
};
